(function () {
  "use strict";

  var module = angular.module("uwAgenda.agenda");

  // directive for daytask-list
  module.directive("agendaDaytaskList", [
    "$rootScope",
    "DayTaskBroadcast",
    "TaskBroadcast",
    "TaskService",
    "TaskListService",
    "HelperService",
    "DateService",    
    'SharedAgendaService',    
    function (
      $rootScope,
      DayTaskBroadcast,
      TaskBroadcast,
      TaskService,
      TaskListService,
      HelperService,
      DateService,      
      SharedAgendaService,      

    ) {
      var directive = {
        link: link,
        restrict: "E",
        templateUrl: "/app/agenda/templates/agenda-daytask-list.template.html",
        replace: true,
        scope: {
          allowNew: "@",
          patientId: "=?",
        },
      };
      return directive;

      function link(scope, element) {
        // collapsing
        scope.collapsed = false;
        // overview service
        scope.overview = null;
        // task list service
        var service = null;

        // paging state (load-more)
        scope.hasMore = false;
        scope.loadingMore = false;
        var pageKey = 'unknown';
        var agendaIds = null;
        var currentDate = null;

        activate();

        // load next page and append to the existing list
        scope.loadMore = function () {
          if (scope.loadingMore || !scope.hasMore || !agendaIds) { return; }

          scope.loadingMore = true;

          TaskService.getByAgendas(agendaIds, currentDate, pageKey).then(function (result) {
            service.appendPage(result.tasks);
            setStateCounts(result);
            scope.hasMore = scope.overview.data.items.length < scope.overview.data.grandTotal;
            pageKey = result.key;

            // update filters for the newly appended tasks
            $rootScope.$broadcast(TaskBroadcast.RefreshFilter);

            scope.loadingMore = false;
          }, function () {
            scope.loadingMore = false;
          });
        };

        // collapse
        scope.collapse = function () {
          scope.collapsed = !scope.collapsed;
        };

        // show detail view for creating new one
        scope.new = function () {
          TaskService.newTask(false);
        };

        // fullscreen
        scope.fullscreen = function () {
          if (element.hasClass("fullscreen")) {
            element.removeClass("fullscreen");
          } else {
            element.addClass("fullscreen");
          }
        };

        var showReactionListener = scope.$on(
          DayTaskBroadcast.ShowReaction,
          function () {
            if (!element.hasClass("reaction-visible")) {
              element.addClass("reaction-visible");
            }
          }
        );

        var hideReactionListener = scope.$on(
          DayTaskBroadcast.HideReaction,
          function () {
            if (element.hasClass("reaction-visible")) {
              element.removeClass("reaction-visible");
            }
          }
        );

        // activate
        function activate() {
          //disable loading spinner
          //HelperService.block(element);

          // new service
          service = new TaskListService();

          // set overview Service
          scope.overview = service.data.paginationService;

          // current selected date
          var date = DateService.data.date;
          // collapse
          scope.collapsed = false;

          var dayTasksAgendas = SharedAgendaService.getDayTasksAgendas();
          scope.agendaNames = dayTasksAgendas.map(function(agenda) {
            return agenda.owner.company || agenda.owner.caption;
          });
          scope.agendaNamesVisible = dayTasksAgendas.length > 1 ||
                    (dayTasksAgendas.length === 1 &&
                      dayTasksAgendas[0].owner.groupPracticeId);

          var ids = dayTasksAgendas.map(agenda => agenda.id);

          // get from agenda or get from patient
          if (!scope.patientId) {
            // remember for load-more
            agendaIds = ids;
            currentDate = date;
            pageKey = 'unknown';

            // get first page of tasks for the agendas, as indicated in the current view
            TaskService.getByAgendas(ids, date, pageKey).then(function (result) {
              readPaged(result, ids);
            });
          }
          else {
            // get all tasks from patient (not paged on the backend)
            TaskService.getByPatient(scope.patientId).then(function (result) {
              read(result, ids);
            });
          }

        } // activate

        // read a page of tasks from the paged agendas-endpoint
        function readPaged(result, ids) {
          setStateCounts(result);
          read(result.tasks, ids);
          scope.hasMore = scope.overview.data.items.length < scope.overview.data.grandTotal;
          pageKey = result.key;
        } // readPaged

        // keep track of the state counts and grand total returned by the backend (over all pages, not just the loaded ones)
        function setStateCounts(result) {
          scope.overview.data.grandTotal = result.total;
          scope.overview.data.stateCounts = {
            InProgress: result.inProgress,
            Finished: result.finished,
            FollowUpByOperator: result.followUpByOperator,
            FollowUpByRingfoon: result.followUpByRingfoon,
          };
        } // setStateCounts

        // read tasks from service
        function read(result, ids) {
          // init service
          if (service !== null) {
            service.init(result, ids, false);
          }

          // update filters
          $rootScope.$broadcast(TaskBroadcast.RefreshFilter);

          // HelperService.unblock(element);
        } // read

        // on destroy
        scope.$on("$destroy", function () {
          service.clean();
          service = null;

          if (showReactionListener) {
            showReactionListener();
            showReactionListener = null;
          }

          if (hideReactionListener) {
            hideReactionListener();
            hideReactionListener = null;
          }
        });
      } // link
    },
  ]);
})();
